module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_8003.8343e8a7.png";